import React from 'react';
import LogDetailComponent from './LogDetailComponent';
import LogDetailHeader from './LogDetailHeader';
import { useQueryWithSimpleErrorHandling } from 'hooks';
import { LOG_QUERY } from '../../queries';
import { useParams } from 'react-router-dom';

const LogDetailContainer = () => {
  const params = useParams();
  const id = params.id;

  const { loading, data, refetch } = useQueryWithSimpleErrorHandling(LOG_QUERY, {
    variables: { logId: id }
  });

  if (!loading && data && data.log && data.log.correlationId === null) {
    refetch({ logId: id });
  }

  return (
    <>
      <LogDetailHeader />
      <LogDetailComponent log={data && data.log} loading={loading}></LogDetailComponent>
    </>
  );
};

export default LogDetailContainer;
